import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.boltin.com';
const LABELS_API_PATH = '/api/labels';

export const renderLabel = async ({ templateId, productId, data }) => {
  const response = await axios.post(`${API_BASE_URL}${LABELS_API_PATH}/render`, {
    templateId,
    productId,
    data,
  });
  return response.data;
};

const labelService = {
  renderLabel,
};

export default labelService;
